import { useEffect, useState } from "react";
import Modal from "react-modal";
import { Content } from "./components/Content";
import { Header } from "./components/Header";
import { api } from "./services/api";
import { Candidato } from "./types/Candidato";

import comonStyles from './styles/comon.module.scss'

Modal.setAppElement('#root');

function App() {
  const [candidato, setCandidato] = useState({} as Candidato);
  const [loading, setLoading] = useState(true)
  async function getUser(uniq: string) {
    setLoading(true)
    
    const { data } = await api.get<Candidato>('/indicado', { params: { uniq } })
    setCandidato(data)
    setLoading(false)
  }

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const uniq = urlParams.get('uniq');

    uniq && getUser(uniq)
  }, [])
  return (
    <>
      <Header />
      <main className={comonStyles.main}>
        {loading
          ? (<div className={comonStyles.content}>
            <h1>
              Consultando ...
            </h1>
          </div>)
          : (<Content candidato={candidato} />)
        }
      </main>
    </>
  );
}

export default App;
